import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import ThankYouSlipReportDetailedLayer from "../components/ThankYouSlipReportDetailedLayer";

const ThankYouSlipReportDetailedPage = () => {
    return (
        <MasterLayout>
            <ThankYouSlipReportDetailedLayer />
        </MasterLayout>
    );
};

export default ThankYouSlipReportDetailedPage;
